import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Hidden,
  TableRow,
  TableCell,
} from '@material-ui/core';

import { Check } from '@material-ui/icons';

import TableActions from '../TableActions';
import { Can } from '../../utils/ability-context';
import monthName from '../../utils/monthName';

class Row extends PureComponent {
  handleShow(id) {
    this.props.history.push(`/paychecks/${id}`);
  }

  render() {
    const { paycheck: {
      id,
      month,
      year,
      seen,
      employee,
    }, paycheck } = this.props;

    return (
      <TableRow
        hover
        tabIndex={-1}
      >
        <Can I="read employee_number" of={paycheck}>
          { employee &&
            <TableCell width={50}>{employee.employee_profile.employee_number}</TableCell>
          }
        </Can>
        <Can I="read name" of={paycheck}>
          { employee && <TableCell padding="none">{`${employee.first_name} ${employee.last_name}`}</TableCell> }
        </Can>
        <Can I="read identity_number" of={paycheck}>
          <Hidden xsDown>
            { employee && <TableCell padding="none">{employee.employee_profile.identity_number}</TableCell> }
          </Hidden>
        </Can>
        <TableCell padding="none">{`${monthName(month)} ${year}`}</TableCell>
        <TableCell width={50} padding="none">{ seen && <Check /> }</TableCell>
        <TableActions
          destroy={false}
          edit={false}
          onShow={() => this.handleShow(id)}
        />
      </TableRow>
    );
  }
}

export default Row;

Row.propTypes = {
  paycheck: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Paychecks/Row.js